import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link, NavLink, useLocation } from 'react-router-dom';
import css from './styles';
import logo from './logo.png';

import Home from './pages/Home';
import Hakkimizda from './pages/Hakkimizda';
import Hizmetler from './pages/Hizmetler';
import Urunler from './pages/Urunler';
import Iletisim from './pages/Iletisim';

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <nav>
        <Link to="/" className="logo-link" onClick={() => setOpen(false)}>
          <img src={logo} alt="Element Group Companies" className="nav-logo" />
        </Link>
        <ul className="nav-links">
          <li><NavLink to="/hizmetler">Hizmetler</NavLink></li>
          <li><NavLink to="/urunler">Ürünler</NavLink></li>
          <li><NavLink to="/hakkimizda">Hakkımızda</NavLink></li>
          <li><NavLink to="/iletisim">İletişim</NavLink></li>
        </ul>
        <Link to="/iletisim" className="nav-cta" onClick={() => setOpen(false)}>Teklif Al</Link>
        <button className={`hamburger ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </button>
      </nav>

      <div className={`mobile-menu ${open ? 'open' : ''}`}>
        <Link to="/hizmetler" onClick={() => setOpen(false)}>Hizmetler</Link>
        <Link to="/urunler" onClick={() => setOpen(false)}>Ürünler</Link>
        <Link to="/hakkimizda" onClick={() => setOpen(false)}>Hakkımızda</Link>
        <Link to="/iletisim" onClick={() => setOpen(false)}>İletişim</Link>
        <Link to="/iletisim" className="nav-cta" onClick={() => setOpen(false)}>Teklif Al</Link>
      </div>
    </>
  );
}

function Footer() {
  return (
    <footer style={{
      background: '#1A1008',
      padding: '16px 40px',
      minHeight: '80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      flexWrap: 'wrap',
      gap: '12px',
    }}>
      <Link to="/" className="footer-logo-link">
        <img src={logo} alt="Element Group Companies" className="footer-logo-img" />
      </Link>
      <div className="footer-links" style={{display:'flex', gap:'20px', flexWrap:'wrap', justifyContent:'center'}}>
        <Link to="/hizmetler">Hizmetler</Link>
        <Link to="/urunler">Ürünler</Link>
        <Link to="/hakkimizda">Hakkımızda</Link>
        <Link to="/iletisim">İletişim</Link>
      </div>
      <div style={{display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'8px'}}>
        <div style={{display:'flex', gap:'12px'}}>
          <a href="https://www.instagram.com/wooddy.co/" target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
            <i className="fa-brands fa-instagram" />
          </a>
          <a href="https://www.facebook.com/wooddy.co?mibextid=ZbWKwL&utm_source=ig&utm_medium=social&utm_content=link_in_bio" target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
            <i className="fa-brands fa-facebook-f" />
          </a>
          <a href="https://maps.app.goo.gl/xz6Azm8YzikSbv1q6" target="_blank" rel="noopener noreferrer" className="social-link" title="Konum">
            <i className="fa-solid fa-location-dot" />
          </a>
        </div>
        <span className="footer-copy">© 2010 – 2026 ElementGlobal. Tüm hakları saklıdır.</span>
      </div>
    </footer>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <style>{css}</style>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<Hakkimizda />} />
        <Route path="/hizmetler" element={<Hizmetler />} />
        <Route path="/urunler" element={<Urunler />} />
        <Route path="/iletisim" element={<Iletisim />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}